var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCondition = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Condition"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M22.4657 1.61166C21.4381 0.579927 20.0419 0 18.5857 0C17.1294 0 15.7332 0.579927 14.7056 1.61166L1.68899 14.6283C0.657259 15.6559 0.0773315 17.0521 0.0773315 18.5083C0.0773315 19.9645 0.657259 21.3608 1.68899 22.3883C2.71659 23.4201 4.11279 24 5.56901 24C7.02522 24 8.42148 23.4201 9.44903 22.3883L22.4657 9.3717C23.4974 8.3441 24.0773 6.94789 24.0773 5.49168C24.0773 4.03546 23.4974 2.6392 22.4657 1.61166ZM12.7032 5.36641L18.7109 11.3428L11.4203 18.6334L5.4439 12.657L12.7032 5.36641ZM8.54139 21.5121C7.74909 22.3052 6.67416 22.7507 5.5532 22.7507C4.4324 22.7507 3.35748 22.3052 2.56517 21.5121C1.77202 20.7197 1.32653 19.6448 1.32653 18.524C1.32653 17.4031 1.772 16.3281 2.56517 15.5358L4.56773 13.5333L10.5441 19.5409L8.54139 21.5121ZM21.5893 8.46412L19.5868 10.4667L13.6104 4.45899L15.6129 2.45643C16.4052 1.66351 17.4802 1.21802 18.6011 1.21802C19.7219 1.21802 20.7969 1.66349 21.5892 2.45643C22.3919 3.25003 22.8435 4.33171 22.8435 5.46039C22.8435 6.58901 22.3919 7.67075 21.5892 8.46412H21.5893Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M10.9822 9.66894C11.2876 9.97428 11.2876 10.4697 10.9822 10.7751C10.6767 11.0807 10.1814 11.0807 9.87586 10.7751C9.57051 10.4697 9.57051 9.97429 9.87586 9.66894C10.1814 9.36337 10.6767 9.36337 10.9822 9.66894Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M12.7093 11.4212C13.0147 11.7268 13.0147 12.222 12.7093 12.5276C12.4038 12.8329 11.9085 12.8329 11.603 12.5276C11.2976 12.222 11.2976 11.7268 11.603 11.4212C11.9085 11.1156 12.4038 11.1156 12.7093 11.4212Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M9.17691 11.4178C9.48248 11.7234 9.48248 12.2186 9.17691 12.5242C8.87134 12.8296 8.37611 12.8296 8.07053 12.5242C7.76519 12.2187 7.76519 11.7234 8.07053 11.4178C8.3761 11.1123 8.87133 11.1123 9.17691 11.4178Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M10.9571 13.1483C11.2624 13.4536 11.2624 13.9491 10.9571 14.2544C10.6515 14.56 10.1563 14.56 9.85071 14.2544C9.54514 13.9491 9.54514 13.4536 9.85071 13.1483C10.1563 12.8427 10.6515 12.8427 10.9571 13.1483Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M12.587 8.00275C12.8925 8.30832 12.8925 8.80355 12.587 9.10913C12.2814 9.41471 11.7862 9.4147 11.4808 9.10913C11.1752 8.80356 11.1752 8.30833 11.4808 8.00275C11.7862 7.69741 12.2814 7.69741 12.587 8.00275Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M14.3677 9.77678C14.6731 10.0824 14.6731 10.5776 14.3677 10.8832C14.0621 11.1885 13.5669 11.1885 13.2613 10.8832C12.956 10.5776 12.956 10.0824 13.2613 9.77678C13.5669 9.47122 14.0621 9.47122 14.3677 9.77678Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M14.4107 13.1108C14.7161 13.4164 14.7161 13.9116 14.4107 14.2172C14.1052 14.5228 13.6099 14.5228 13.3043 14.2172C12.999 13.9117 12.999 13.4164 13.3043 13.1108C13.6099 12.8055 14.1051 12.8055 14.4107 13.1108Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  d: "M12.6803 14.891C12.9859 15.1966 12.9859 15.6918 12.6803 15.9974C12.3747 16.3028 11.8795 16.3028 11.5739 15.9974C11.2686 15.6919 11.2686 15.1966 11.5739 14.891C11.8795 14.5855 12.3747 14.5855 12.6803 14.891Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_10",
  d: "M16.0596 11.476C16.3652 11.7815 16.3652 12.2768 16.0596 12.5823C15.754 12.8879 15.2588 12.8879 14.9532 12.5823C14.6479 12.2768 14.6479 11.7815 14.9532 11.476C15.2588 11.1706 15.754 11.1706 16.0596 11.476Z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCondition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/condition.725ec8bd8cdafe7a2c1174fc6cb5055e.svg";